import React from 'react'
import { StatusByIDsAction } from './status-action'
import { getMostPermissiveRole, hasRole } from '../roles'
import { css, cx } from '@emotion/css'

type Role = 'VIEW' | 'EDIT' | 'RULES_ADMIN' | 'ADMIN'

interface Vulnerability {
  uuid: string
  application: {
    roles: string[]
  }
  status: string
  pending_status?: string
  pending_status_creation_time?: string
}

interface Props {
  vulnerabilities: Vulnerability[]
  refresh: () => Promise<any>
  organizationUuid: string
}

export function UpdateStatusesLegacy({
  vulnerabilities,
  refresh,
  organizationUuid
}: Props) {
  const role = getMostPermissiveRole(getRoles(vulnerabilities))
  const disabled = vulnerabilities.length === 0 && !hasRole(role, 'EDIT')

  return (
    <div
      className={cx(
        css`
          & > div {
            color: #3a3a3a;
            background-color: #f9f9f9;
            border: 1px solid #ececec;
            white-space: nowrap;
            padding: 6px 12px 7px;
            font-size: 14px;
            border-radius: 3px;
          }
        `,
        disabled
          ? css`
              & > div {
                pointer-events: none;
                cursor: default;
                opacity: 0.55;
              }
            `
          : css`
              & > div {
                & :hover {
                  background-color: #f4f4f4;
                }
              }
            `
      )}
    >
      <StatusByIDsAction
        menuPlacement="bottom"
        applicationRole={role}
        refresh={refresh}
        refetchQueries={[]}
        organizationID={organizationUuid}
        vulnerabilities={vulnerabilities.map(
          ({ uuid: id, status, pending_status: pendingStatus }) => ({
            id,
            status,
            pendingStatus:
              typeof pendingStatus !== 'undefined'
                ? {
                    status: pendingStatus
                  }
                : undefined
          })
        )}
      />
    </div>
  )
}

function getRoles(vulnerabilities: Vulnerability[]): Role[] {
  const results: string[] = []
  vulnerabilities.forEach((v) => {
    if (v.application && v.application.roles) {
      v.application.roles.forEach((prefixedRole) => {
        const role = prefixedRole.slice(5)
        if (results.length < 4 || results.every((result) => result !== role)) {
          results.push(role)
        }
      })
    }
  })
  return results as Role[]
}
